/* eslint-disable */
import workersAPI from "./workers_service";
import {
  fetchWorkers,
  addWorker,
  updateWorker,
  deleteWorker,
  setLoading,
  setError,
} from "../../redux/workers/workers";

export const fetchAllWorkers = () => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const data = await workersAPI.getAllWorkers();
      dispatch(fetchWorkers(data.workers || []));
      return { success: true, data };
    } catch (error) {
      const apiError = error.response?.data;
      dispatch(setError(apiError?.message || "Failed to fetch workers"));
      console.error("Error fetching workers:", error);
      return {
        success: false,
        error: apiError?.error || "UNKNOWN_ERROR",
        message: apiError?.message || "حدث خطأ في جلب العاملين",
      };
    }
  };
};

export const inviteNewWorker = (workerData) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await workersAPI.inviteWorker(workerData);

      // Add the new worker to Redux state
      dispatch(addWorker(response.worker));

      return { success: true, data: response };
    } catch (error) {
      dispatch(
        setError(error.response?.data.message || "Failed to invite worker")
      );
      const apiError = error.response?.data;

      return {
        success: false,
        error: apiError?.error || "UNKNOWN_ERROR",
        message: apiError?.message || "حدث خطأ غير متوقع",
        code: apiError?.code,
      };
    }
  };
};

export const changeWorkerPermissions = (workerId, permissions, products) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const response = await workersAPI.updateWorkerPermissions(
        workerId,
        permissions,
        products
      );

      dispatch(updateWorker(response.worker));

      return { success: true, data: response };
    } catch (error) {
      const apiError = error.response?.data;
      dispatch(setError(apiError?.message || "Failed to update permissions"));

      return {
        success: false,
        error: apiError?.error || "UNKNOWN_ERROR",
        message: apiError?.message || "حدث خطأ في تحديث الصلاحيات",
      };
    } finally {
      dispatch(setLoading(false));
    }
  };
};

export const removeWorker = (workerId) => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      await workersAPI.deleteWorker(workerId);

      dispatch(deleteWorker(workerId));

      return { success: true };
    } catch (error) {
      const apiError = error.response?.data;
      dispatch(setError(apiError?.message || "Failed to delete worker"));

      return {
        success: false,
        error: apiError?.error || "UNKNOWN_ERROR",
        message: apiError?.message || "حدث خطأ في حذف العامل",
      };
    }
  };
};

